/* eslint-disable import/prefer-default-export */
import { getTrackingHomeOrderType } from '../../selectors/trackingSelectors';

import { TRACK_TAPPED_TIME_PICKER } from './types';

export const trackTappedTimePicker = (sourceView) => (dispatch, getState) => {
  const state = getState();

  return dispatch({
    type: TRACK_TAPPED_TIME_PICKER,
    payload: {
      name: 'Tapped Time Picker',
      properties: {
        ...getTrackingHomeOrderType(state),
        'Source view': sourceView,
      },
    },
  });
};
